const REACT_QUERY_KEYS_REVIEWS_INSIGHTS = {
  reviewsTendLineChart: 'reviewsTendLineChart',
  reviewsSankeyChart: 'reviewsSankeyChart',
  lastSelectedReviewCycle: 'lastSelectedReviewCycle',
};

export default REACT_QUERY_KEYS_REVIEWS_INSIGHTS;
